import ReconnectingWebSocket from 'reconnecting-websocket';
import { toast } from 'react-toastify';
import { store } from '../../store';
import { updateIsChatServiceReady } from '../../store/slices/sessionSlice';
import { handleSystemTypeData } from './handleSystemType';
import { handleUserTypeData } from './handleUserType';
import { handleWhiteboardMsg } from './handleWhiteboardType';
import { onAfterOpenConnection } from './handleAfterOpenConnection';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../proto/plugnmeet_datamessage_pb';
import { AnalyticsDataMsg, AnalyticsEventType, } from '../proto/plugnmeet_analytics_pb';
import i18n from '../i18n';
let isConnected = false, normallyClosed = false, isReconnecting = false, isFirstTime = true;
let ws;
const toastId = 'websocketStatus';
const createWS = () => {
    console.log('socket', getURL);
    ws = new ReconnectingWebSocket(getURL, [], {
        minReconnectionDelay: 2000,
        maxRetries: 20,
    });
    ws.binaryType = 'arraybuffer';
    ws.onopen = () => {
        isConnected = true;
        isFirstTime = false;
        onAfterOpenConnection();
        store.dispatch(updateIsChatServiceReady(true));
        if (isReconnecting) {
            isReconnecting = false;
            toast.dismiss(toastId);
        }
    };
    ws.onclose = () => {
        isConnected = false;
        store.dispatch(updateIsChatServiceReady(false));
        if (!normallyClosed) {
            toast.loading(i18n.t('notifications.websocket-disconnected'), {
                type: 'error',
                autoClose: false,
                toastId: toastId,
                closeButton: true,
            });
            isReconnecting = true;
        }
    };
    ws.onerror = () => {
        toast(i18n.t('notifications.websocket-error'), {
            type: 'error',
            autoClose: 5000,
            toastId: toastId,
        });
    };
    ws.onmessage = (event) => {
        onMessage(event);
    };
};
const onMessage = (event) => {
    if (event.data) {
        let data;
        try {
            data = DataMessage.fromBinary(new Uint8Array(event.data));
        }
        catch (e) {
            console.error(e);
            return;
        }
        if (data.type === DataMsgType.USER && data.body) {
            handleUserTypeData(data.body, data.messageId, data.to);
        }
        else if (data.type === DataMsgType.SYSTEM) {
            handleSystemTypeData(data);
        }
        else if (data.type === DataMsgType.WHITEBOARD) {
            if (data.body) {
                handleWhiteboardMsg(data.body);
            }
        }
    }
};
const getURL = () => {
    const url = new URL(window.PLUG_N_MEET_SERVER_URL);
    const session = store.getState().session;
    let webSocketUrl;
    let protocol = 'ws://';
    if (url.protocol === 'https:') {
        protocol = 'wss://';
    }
    webSocketUrl = protocol + url.host;
    if (url.pathname !== '/') {
        webSocketUrl = webSocketUrl + url.pathname;
    }
    const token = session.token;
    const currentUser = session.currentUser;
    const currentRoom = session.currentRoom;
    webSocketUrl =
        webSocketUrl +
            '/ws?token=' +
            token +
            '&roomSid=' +
            currentRoom.sid +
            '&userSid=' +
            (currentUser === null || currentUser === void 0 ? void 0 : currentUser.sid) +
            '&roomId=' +
            currentRoom.room_id +
            '&userId=' +
            (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
    return webSocketUrl;
};
export const openWebsocketConnection = () => {
    createWS();
};
export const isSocketConnected = () => isConnected;
export const sendWebsocketMessage = (msg) => {
    if (!isFirstTime && !isConnected && !normallyClosed) {
        toast(i18n.t('notifications.websocket-not-connected'), {
            type: 'error',
            toastId: 'websocket-notify',
            autoClose: 2000,
        });
    }
    ws === null || ws === void 0 ? void 0 : ws.send(msg);
};
export const sendAnalyticsByWebsocket = (event_name, event_type = AnalyticsEventType.USER, hset_value, event_value_string, event_value_integer) => {
    var _a, _b, _c, _d, _e;
    const session = store.getState().session;
    const analyticsMsg = new AnalyticsDataMsg({
        eventType: event_type,
        eventName: event_name,
        roomId: session.currentRoom.room_id,
        userId: (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.userId,
        hsetValue: hset_value,
        eventValueString: event_value_string,
        eventValueInteger: event_value_integer,
    });
    const dataMsg = new DataMessage({
        type: DataMsgType.SYSTEM,
        roomSid: session.currentRoom.sid,
        roomId: session.currentRoom.room_id,
        body: {
            type: DataMsgBodyType.ANALYTICS_DATA,
            from: {
                sid: (_c = (_b = session.currentUser) === null || _b === void 0 ? void 0 : _b.sid) !== null && _c !== void 0 ? _c : '',
                userId: (_e = (_d = session.currentUser) === null || _d === void 0 ? void 0 : _d.userId) !== null && _e !== void 0 ? _e : '',
            },
            msg: analyticsMsg.toJsonString(),
        },
    });
    sendWebsocketMessage(dataMsg.toBinary());
};
export const closeWebsocketConnection = () => {
    if (isConnected) {
        normallyClosed = true;
        ws === null || ws === void 0 ? void 0 : ws.close();
    }
};
